var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.53086 13.2188C4.56602 13.2188 4.60117 13.2152 4.63633 13.21L7.59297 12.6914C7.62812 12.6844 7.66152 12.6686 7.68613 12.6422L15.1375 5.19082C15.1538 5.17456 15.1667 5.15524 15.1755 5.13398C15.1844 5.11271 15.1889 5.08992 15.1889 5.06689C15.1889 5.04387 15.1844 5.02108 15.1755 4.99981C15.1667 4.97855 15.1538 4.95923 15.1375 4.94297L12.216 2.01973C12.1826 1.98633 12.1387 1.96875 12.0912 1.96875C12.0437 1.96875 11.9998 1.98633 11.9664 2.01973L4.51504 9.47109C4.48867 9.49746 4.47285 9.5291 4.46582 9.56426L3.94727 12.5209C3.93017 12.6151 3.93628 12.712 3.96507 12.8033C3.99386 12.8945 4.04446 12.9774 4.1125 13.0447C4.22852 13.1572 4.37441 13.2188 4.53086 13.2188ZM5.71563 10.1531L12.0912 3.7793L13.3797 5.06777L7.0041 11.4416L5.44141 11.7176L5.71563 10.1531ZM15.4697 14.6953H2.53223C2.22109 14.6953 1.96973 14.9467 1.96973 15.2578V15.8906C1.96973 15.968 2.03301 16.0312 2.11035 16.0312H15.8916C15.9689 16.0312 16.0322 15.968 16.0322 15.8906V15.2578C16.0322 14.9467 15.7809 14.6953 15.4697 14.6953Z",
    fill: "#240C0C"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.ea1702cac0902ca0b17e9ff128611091.svg";
export { ForwardRef as ReactComponent };